/**
 * Copyright © Scandiweb, Inc. All rights reserved.
 *
 * @category    Puma
 * @package     Puma_Wishlist
 * @author      Beshoy Samuel <info@scandiweb.com>
 */

import ProductListQuery from 'Query/ProductList.query';
import { WishlistQuery as SourceQuery } from 'SourceQuery/Wishlist.query';
import { Field, Fragment } from 'Util/Query';

/** @namespace Scandipwa/Query/Wishlist/Query */
export class WishlistQuery extends SourceQuery {
    addProductsToWishlist(wishlistId, wishlistItems) {
        return new Field('s_saveWishlistItem')
            .addArgument('wishlistItem', 'WishlistItemInput!', wishlistItems[0])
            .addField(this._getWishlistErrorsField());
    }

    _getProductField() {
        return new Field('product')
            .addFieldList(this._getWishlistProductInterfaceFields());
    }

    _getWishlistProductInterfaceFields() {
        const fields = [
            'id',
            'sku',
            'name',
            'type_id',
            'color',
            'style_number',
            'url',
            ProductListQuery._getAttributesField(false),
            this._getConfigurableProductFragment()
        ];

        return fields;
    }

    _getConfigurableProductFragment() {
        return new Fragment('ConfigurableProduct')
            .addFieldList(this._getConfigurableProductFragmentFields());
    }

    _getConfigurableProductFragmentFields() {
        return [
            ProductListQuery._getConfigurableOptionsField(),
            this._getVariantsField()
        ];
    }

    _getVariantsField() {
        return new Field('variants')
            .addFieldList(this._getVariantFields());
    }

    _getVariantFields() {
        return [
            this._getProductVariantsField()
        ];
    }

    _getProductVariantsField() {
        return new Field('product')
            .addFieldList(this._getWishlistVariantInterfaceFields());
    }

    _getWishlistVariantInterfaceFields() {
        const fields = [
            'id',
            'sku',
            'name',
            'type_id',
            'color',
            'style_number',
            ProductListQuery._getProductThumbnailField(),
            ProductListQuery._getPriceRangeField(),
            ProductListQuery._getTierPricesField()
        ];

        return fields;
    }
}

export default new WishlistQuery();
